import { render, staticRenderFns } from "./FareOptionsList.vue?vue&type=template&id=8c5c298e&scoped=true&"
import script from "./FareOptionsList.vue?vue&type=script&lang=js&"
export * from "./FareOptionsList.vue?vue&type=script&lang=js&"
import style0 from "./FareOptionsList.vue?vue&type=style&index=0&id=8c5c298e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5c298e",
  null
  
)

export default component.exports